import React, {Component} from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import {Minus, Plus} from 'react-feather';

class ProductPopup extends Component{
  handleClickOutside() {
    this.props.togglePopup();
  }

  render() {
    return(
      <div className="ProductPopup">
        <div
          className="Product-image"
          style={{backgroundImage: `url(${this.props.image})`}} >
        </div>
        <div className="Product-bottom">
          <p className="Product-image-warning">
            OBS! Bilden är enbart ett exempel av hur en låda kan se ut.
          </p>
          <div className="Product-info">
            <p className="Product-title">{this.props.title}</p>
            <p className="Product-price">{this.props.price}kr</p>
          </div>
          <div className="Product-buttons">
            {
              this.props.quantity > 0
              ?
              <div className="Product-quantity-btn">
                <button onClick={() => this.props.reduceQuantity(this.props.id, this.props.theMonth)}>
                  <Minus />
                </button>
                <span>{this.props.quantity}</span>
                <button onClick={() => this.props.addToCart(this.props, this.props.theMonth)}>
                  <Plus />
                </button>
              </div>
              :
              <button className="Product-add-btn"
                onClick={() => this.props.addToCart(this.props, this.props.theMonth)}>
                Lägg Till
              </button>
            }
          </div>
        </div>
        <p>{this.props.description}</p>
      </div>
    )
  }
}

export default enhanceWithClickOutside(ProductPopup);



// WEBPACK FOOTER //
// ./src/components/ProductPopup.jsx